import { IconCloudUpload, IconLoader2 } from '@tabler/icons-react'
import { useState } from 'react'
import { MonthCode } from 'src/API/rest.forecast_regionwise'
import { useStatesAPI } from 'src/API/rest.states'
import { ButtonIconSquare } from 'src/components/buttons'
import { FileInputDragDropStandard } from 'src/components/standard.fileDroper'
import { DatePickerStandard, InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { TypographyH2 } from 'src/components/typography'
import { RefMonthComponent } from './component.refMonth'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { useRestAPI } from 'src/API/axiosAPI'
import { useStylewiseForcast } from 'src/API/rest.stylewiseForcast'
import { ProgressFullScreen } from 'src/components/progressLoading'
import { toast } from 'src/shadcn/ui/use-toast'
import { Input } from 'src/shadcn/ui/input'
import { format, parse } from 'date-fns'
import DatePicker from 'react-datepicker'
import { useSecondarySalesData } from 'src/API/rest.secSalesData'
import { ModalValidationError } from './component.validationErrorModal'

interface InvalidData {
    invalid_products: string[];
    invalid_skus: string[];
    invalid_distributors: string[];
    invalid_product_distributor_mappings: string[];
}

type MonthType = {
    month: string;
    value: string;
}

function validateDateRange(startDateStr: string, endDateStr: string): true | string {
    // Convert strings to Date objects
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    if (startDate.getFullYear() !== endDate.getFullYear() || startDate.getMonth() !== endDate.getMonth()) {
        return "Not in the same month";
    }

    if (startDate > endDate) {
        return "Start date is greater";
    }

    return true;
}

export default function SecondaryDataUpload() {
    const [isOpen, setIsOpen] = useState(false)
    const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false)
    const [startDate, setstartDate] = useState<string | null>(null)
    const [endDate, setendDate] = useState<string | null>(null)
    const [seletedFile, setSelectedFile] = useState<File | null>(null)
    const [validationErrors, setValidationErrors] = useState<InvalidData | null>(null)
    const api = useRestAPI()

    const {
        uploadProgress,
        isvalidateSecondarySalesDataExelError,
        isvalidateingSecondarySalesDataExel,
        validateProgress,
        validateSecondarySalesDataExel,
        uploadSecondarySalesDataExel,
        isUploadingSecondarySalesDataExel,
        downloadSecondarySalesTemplate,
        isDownloadingSecondarySalesTemplates,
        isErrorDownloadingSecondarySalesTemplates
    } = useSecondarySalesData({})

    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })

    const {
        states,
        isLoading: isLoadingState,
        isError: isErrorState,
        isFetching: isFetchingState
    } = useStatesAPI({
        trigger: true
    });

    const handleDownloadTemplate = async () => {
        setIsDownloadingTemplate(true);
        await downloadSecondarySalesTemplate();
        setIsDownloadingTemplate(false);
    };

    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow flex flex-col overflow-auto items-center '>
            <ProgressFullScreen
                progress={validateProgress}
                show={isvalidateingSecondarySalesDataExel}
                subTitle='Validating file...'
            />
            <ProgressFullScreen
                progress={uploadProgress}
                show={false}
                subTitle='uploading file...'
            />

            <ModalValidationError
                invalidData={validationErrors || null}
                show={isOpen}
                setShow={setIsOpen}
            />

            {/* Ref Month
            <RefMonthComponent
                forecastMonth={latestCalendarDate?.date || ''}
                isFetchingLatestForecastCalender={isFetchinglatestCalendarDate}
            /> */}
            <div className=' text-center flex text-vstargray-800 dark:text-vstargray-100 py-2'>
                Download Template {isDownloadingSecondarySalesTemplates ? <IconLoader2 size={10} className=' inline animate-spin' /> : <span onClick={handleDownloadTemplate} className=' underline text-blue-500 cursor-pointer hover:text-blue-700'>here</span>}
            </div>

            {/* NP style wise */}
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900 rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-3 '>
                    <TypographyH2>Secondary Sales Data Upload</TypographyH2>
                    <div className=' flex gap-2 '>
                        <DatePickerStandard
                            title='Start Date'
                            className=' border p-2 rounded-md'
                            selected={startDate ? new Date(startDate) : null}
                            onChange={(date) => {
                                if (!date)
                                    setstartDate(null)
                                else
                                    setstartDate(format(date as Date, 'yyyy-MM-dd'))
                            }}
                            dateFormat="dd-MMM-yyyy"
                        />
                        <DatePickerStandard
                            title='End Date'
                            className=' border p-2 rounded-md'
                            selected={endDate ? new Date(endDate) : null}
                            onChange={(date) => {
                                if (!date)
                                    setendDate(null)
                                else
                                    setendDate(format(date as Date, 'yyyy-MM-dd'))
                            }}
                            dateFormat="dd-MMM-yyyy"
                        />
                    </div>
                    <div className=' grow flex items-center w-min mx-auto mt-8'>
                        <FileInputDragDropStandard
                            onDrop={async (file) => {
                                if (!startDate || !endDate) {
                                    toast({
                                        description: 'Please select start and end date',
                                        title: 'Error'
                                    })
                                    return
                                }
                                const response1 = validateDateRange(startDate!, endDate!)
                                if (response1 !== true) {
                                    toast({
                                        description: response1,
                                        title: 'Error'
                                    })
                                    return;
                                }

                                const response = await validateSecondarySalesDataExel({
                                    file: file!
                                })
                                if (response.success === false) {
                                    toast({
                                        description: response.message
                                    })
                                    setValidationErrors(response.errors || null)
                                    if (response.errors)
                                        setIsOpen(true)
                                } else {
                                    setSelectedFile(file);
                                }
                            }}
                            file={seletedFile}
                            onClear={() => setSelectedFile(null)}
                            accept={{
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                                'text/csv': ['.csv']
                            }}
                        />
                    </div>
                    <ButtonIconSquare
                        disabled={seletedFile === null}
                        className=' mx-auto mb-5'
                        icon={isUploadingSecondarySalesDataExel ? <IconLoader2 className='animate-spin' /> : <IconCloudUpload />}
                        onClick={async () => {
                            const response = await uploadSecondarySalesDataExel({
                                file: seletedFile!,
                                start_date: startDate!,
                                end_date: endDate!
                            })
                            if (response.success === false) {
                                toast({
                                    title: 'Error',
                                    description: response.message
                                })
                            } else {
                                toast({
                                    title: 'Success',
                                    description: response.message
                                })
                                setSelectedFile(null)
                            }
                        }}
                        variant='secondary' text='Submit' />
                </div>
            </div>
        </div>
    )
}